<h1 mat-dialog-title class="notification-title">
	{{ 'docs.mappings.edit.windowHeader' | translate }}
</h1>

<mat-dialog-content style="padding-top: 20px">
	<div class="optional-form-fields">
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="labelFixedWidth">
				<span [ngClass]="{ error: tagsErrorMessage }">
					{{ tagsErrorMessage ? tagsErrorMessage : ('docs.mappings.edit.editTagsHeader' | translate) }}
				</span>
			</mat-label>
			<input matInput type="text" [(ngModel)]="tagsString" [ngClass]="{ error: tagsErrorMessage }" (blur)="editTags()" (input)="onEdit($event)" />
		</mat-form-field>
	</div>

	<div class="optional-form-fields">
		<label>{{ 'docs.mappings.edit.editMappingsHeader' | translate }}</label>
		<br />
		@for (mapping of systemMappings; track mapping; let i = $index) {
			<div class="mapping-row">
				<mat-form-field appearance="outline" class="mapping-field small">
					<input matInput type="text" [(ngModel)]="mapping.key" placeholder="{{ 'docs.mappings.edit.key' | translate }}" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="mapping-field small">
					<input matInput type="text" [(ngModel)]="mapping.value" placeholder="{{ 'docs.mappings.edit.value' | translate }}" />
				</mat-form-field>
				<mat-icon svgIcon="acies_delete" class="clickIcon center-vertical" (click)="deleteRow(i)"></mat-icon>
			</div>
		}
		<button mat-button class="button-border-color" (click)="addRow()">
			{{ 'docs.mappings.edit.addRow' | translate }}
		</button>
	</div>
</mat-dialog-content>

<div>
	<div mat-dialog-actions align="end">
		<button mat-stroked-button (click)="onNoClick()" class="button-border-color">
			{{ 'docs.mappings.edit.cancel' | translate }}
		</button>
		<button mat-flat-button color="primary" cdkFocusInitial (click)="onSaveClick()" [disabled]="tagsErrorMessage">
			{{ 'docs.mappings.edit.save' | translate }}
		</button>
	</div>
</div>
